import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";
import mergeDeep from "../util/mergeDeep";

export default function referentieReducer(state = initialState.referentie, action) {
	switch (action.type) {
		case types.REFERENCES_LOADED: {
			return mergeDeep({}, action.body);
		}

		default:
			return state;
	}
}
